import { createProviderToken } from '@core/common-legacy';
import type { AssistantLinkTarget } from '@core/tellent-assistant-types';

/**
 * Host-provided handler for assistant-generated in-app links. Consulted on
 * activation; returns true when it handled the target (the caller then
 * prevents the default web navigation). Web hosts provide nothing and keep
 * plain anchor behavior.
 */
export type TellentAssistantLinkOpener = (target: AssistantLinkTarget) => boolean;

export const {
  provide: provideTellentAssistantLinkOpener,
  inject: injectTellentAssistantLinkOpener,
} = createProviderToken<TellentAssistantLinkOpener>('TELLENT_ASSISTANT_LINK_OPENER')(false);
